import { useQuery } from "react-query";
import API from "../shared-utils/api";
export const getPubMedia = async (pub_id) => {
    if (!pub_id) {
        throw new Error("pub_id is required");
    }
    const { data } = await API.get(`/api/v1/rbzo/pubs/${pub_id}/media`);
    return data;
};
export const usePubMedia = (pub_id) => {
    return useQuery(["pubMedia", pub_id], () => getPubMedia(pub_id), {
        staleTime: 5 * 60 * 1000,
        cacheTime: 7 * 60 * 1000,
        enabled: !!pub_id,
    });
};
